import { Stack } from 'expo-router';
import { useTheme } from '@/context/ThemeContext';

export default function UseCasesLayout() {
  const { colors } = useTheme();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.solid_color_primary },
        animation: 'fade',
      }}
    />
  );
}
